import React from 'react';

interface EvalScoreCardProps {
  /** Composite or per-format weighted score 0-100. */
  score: number | null;
  /** Optional letter grade. */
  grade?: string | null;
  /** Optional per-axis scores to surface (e.g. top 3). */
  axes?: Array<{ name: string; score: number; reason?: string }>;
  /** Heading label. */
  label?: string;
}

/**
 * Compact eval display used by Social Studio for both pre-gen (topic eval)
 * and post-gen (content eval) panels. Score nullability is honest — null
 * renders as "—" instead of misleading 0/100.
 */
export default function EvalScoreCard({ score, grade, axes, label }: EvalScoreCardProps) {
  const display = score === null || score === undefined ? '—' : String(score);
  const tone = score === null || score === undefined
    ? 'var(--text-tertiary)'
    : score >= 80 ? 'var(--success)'
    : score >= 60 ? 'var(--warning)'
    : 'var(--danger)';
  return (
    <div className="eval-card" style={{ border: '1px solid var(--border)', borderRadius: 0, padding: 12, background: 'var(--bg-surface)' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        {label && <span style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>{label}</span>}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <span style={{ fontSize: 28, fontWeight: 600, color: tone }}>{display}</span>
          {grade && <span style={{ fontSize: 14, color: 'var(--text-secondary)' }}>{grade}</span>}
        </div>
      </div>
      {axes && axes.length > 0 && (
        <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0 0', display: 'grid', gap: 4 }}>
          {axes.map((a) => (
            <li key={a.name} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
              <span style={{ color: 'var(--text-secondary)' }}>{a.name}</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--text-primary)' }}>{a.score}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
